import { VCard, VCardTitle, VCardText } from 'vuetify/lib'
import Attachments from '@/views/components/file/attachments.vue'
import VTable from '@/vuetify_custom/v-table/v3'
import { service_in_types } from '@/views/blogger/fields.js'
import styles from './index.module.less'
import {contract_types_mixins} from './EditMixIns.jsx'
// Textareas_Field
import { common_mixins } from './EditMixIns.jsx'
export default {
    mixins:[common_mixins, contract_types_mixins],
    data() {
        return {
            hash: {},
        }
    },
    computed: {
        table_fields() {
            return [
                {
                  text: '加成服务编号',
                  align: 'center',
                  value: 'uid',
                  width: 120,
              }, 
              {
                  text: '服务时间',
                  align: 'center',
                  value: 'service_date',
                  width: 120,
              },
              {
                  text: '服务类型',
                  align: 'center',
                  value: 'service_type',
                  width: 120,
                  type: 'list_field',
                  item_key: 'value',
                  item_text: 'label',
                  items: service_in_types
              },
              {
                  text: '服务金额',
                  align: 'center',
                  value: 'total_price',
                  type: 'money_field',
                  width: 120,
              },
              {
                text: '附件',
                align: 'center',
                value: 'bfiles',
                width: 120,
                render:(_, t) => {
                    if (!t.bfiles || !t.bfiles.length) {
                        return '-'
                    }
                    return <div>
                    <Attachments files={t.bfiles}/>
                </div>
                } 
              },
              ]
        },
 
    },
    methods: {
        changeUid(item, index) {
            this.$set(this.params.placing_ads_vas_records, index, item)
        },
    },
    render() {
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                加成服务
            </VCardTitle>
            <VCardText>
            <VTable
                            headers={this.table_fields}
                            desserts={this.params.placing_ads_vas_records}
            
                        />
            </VCardText>
        </VCard>
    </div>
    }
}